<template>
    <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="id-modalHeadingLisatiedot"
    >
        <header class="modal-header">
            <h1
                id="id-modalHeadingLisatiedot"
                ref="modalHeadingLisatiedot"
                tabindex="0"
                @keydown.tab="handleHeadingTab"
            >
                {{ header }}
            </h1>
            <button
                ref="closeButtonLisatiedot"
                type="button"
                class="btn-close"
                :aria-label="closeModalAriaLabel"
                @click="close"
                @keydown.esc="close"
                @keydown.tab="handleCloseButtonTab"
            />
        </header>
        <section class="modal-body modal-font">
            <dynamic-table
                :table-data="data.tableData"
                :table-heading="heading"
            />
            <p>
                <!-- eslint-disable vue/no-v-html -->
                <span v-html="data.textContent" />
                <!--eslint-enable-->
            </p>
        </section>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"
    import DynamicTable from "@/components/DynamicTable.vue"
    import DynamicModalData from "@/models/dynamicmodaldata"

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class LisatiedotKunnanLaajakaistaliittymistaModal extends Vue {
        @Prop({ type: Boolean, default: false }) componentNameIsSet!: boolean

        mounted(): void {
            if (this.componentNameIsSet === true) {
                this.$nextTick(() => {
                    (this.$refs.modalHeadingLisatiedot as HTMLHeadingElement).focus()
                })
            }
        }

        close(): void {
            this.$store.dispatch("setModalComponentName", "")
        }

        get data(): DynamicModalData | null {
            return this.$store?.getters.modalData ?? null
        }

        get textContent(): string | null {
            return this.data?.textContent ?? ""
        }

        get header(): string | null {
            return this.data?.header ?? ""
        }

        get heading(): string | undefined {
            return this.$t("App.LaajakaistaJaPuhelin.Hintatiedot")
        }

        get closeModalAriaLabel(): string | undefined {
            return this.$t("App.Close")
        }

        // TODO LLa jos modaalin sis�lt��n tulee muita interaktiivisia elementtej� closeButtonin ja otsikon lis�ksi,
        // ne tulee huomioida kohdistuksen k�sittelyss� (trapFocus?)
        handleCloseButtonTab(event: KeyboardEvent): void {
            if (!event.shiftKey) /* tab */ {
                (this.$refs.modalHeadingLisatiedot as HTMLHeadingElement).focus()
                event.preventDefault()
            }
        }

        handleHeadingTab(event: KeyboardEvent): void {
            if (event.shiftKey) /* shift + tab */ {
                (this.$refs.closeButtonLisatiedot as HTMLButtonElement).focus()
                event.preventDefault()
            }
        }
    }
</script>
